import PropTypes from 'prop-types';
import React, { Component } from 'react';
import noop from 'lodash/noop';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import Button from 'yoda-core-components/lib/components/Button/Button';
import classNames from 'classnames/bind';

import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import * as styles from './WrappedComponent.css';

const cx = classNames.bind(styles);

class ApplySyfLink extends Component {
    static propTypes = {
        actions: PropTypes.object.isRequired,
        /**
         * dataHref: Prop needs to be passed
         * for any custom urls or application for customize benefits
         */
        dataHref: PropTypes.string.isRequired,
        applySyf: PropTypes.object,
        buttonType: PropTypes.string,
        children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
        preferences: PropTypes.object,
        buttonClass: PropTypes.string,
        loaderClass: PropTypes.string,
        errorClass: PropTypes.string,
        linkName: PropTypes.string,
        triggerAnalytics: PropTypes.bool,
    };

    static defaultProps = {
        dataHref: '',
        buttonType: 'Link',
        buttonClass: '',
        loaderClass: '',
        applySyf: {},
        actions: {
            customStepUp: noop,
            startSyfApplication: noop,
            triggerNavigationClick: noop,
        },
        children: '',
        errorClass: '',
        preferences: {},
        linkName: '',
        triggerAnalytics: false,
    };

    constructor() {
        super();

        this.state = {
            isLoading: false,
        };
    }

    componentWillReceiveProps(nextProps) {
        const isDataLoaded = !get(nextProps.applySyf, 'forwardFlow.isLoading');
        if (isDataLoaded && this.state.isLoading) {
            this.setState({ isLoading: false });
        }
    }

    onApplyLink = () => {
        const { dataHref } = this.props;

        const {
            actions: { customStepUp, startSyfApplication, triggerNavigationClick },
            preferences: { customSliderConfig },
            triggerAnalytics,
            linkName,
        } = this.props;

        this.setState({ isLoading: true }, () =>
            customStepUp(customSliderConfig, {
                onAuthentication() {
                    startSyfApplication(dataHref);
                },
                onSkip() {
                    // continue as guest
                    startSyfApplication(dataHref, { isContinuedAsGuest: true });
                },
                onClose: () => {
                    this.setState({ isLoading: false });
                },
            })
        );
        if (triggerAnalytics && linkName.length > 0) {
            triggerNavigationClick({
                linkName,
            });
        }
    };

    renderLoader = (loaderClass) => <div className={cx('loader', loaderClass)}>Loading...</div>;

    renderError = (errMsg, errorClass) => <div className={cx('error', errorClass)}>{errMsg}</div>;

    render() {
        const {
            preferences,
            buttonType,
            buttonClass,
            children,
            applySyf,
            loaderClass,
            errorClass,
        } = this.props;
        const { isLoading } = this.state;
        const isError = !isLoading && !isEmpty(get(applySyf, 'forwardFlow.error'));
        return (
            <Button
                size="Sm"
                buttonType={buttonType}
                automationId="applySyfLink"
                onClick={this.onApplyLink}
                isDisabled={isLoading}
                className={`${cx('applySyfLink', buttonClass)} ${dt([
                    'relative',
                    'inline-flex',
                    'leading-[inherit]',
                    'items-center',
                    'no-underline',
                ])}`}
            >
                <div className={cx('text')}>
                    {children
                        ? (typeof children === 'function' && children(isLoading, isError)) ||
                          children
                        : get(preferences, 'text', 'Apply Now')}
                </div>
                {isLoading && this.renderLoader(loaderClass)}
                {/* Error Scenerio */}
                {isError &&
                    this.renderError(
                        get(preferences, 'serviceError', 'Error! Try Again'),
                        errorClass
                    )}
            </Button>
        );
    }
}

export default ApplySyfLink;
